/*
 Created by CHT 2019/12/21 16:00
*/


import {
  SHOW_TYPE__AREA,
  SHOW_TYPE__CLUSTER_BAR,
  SHOW_TYPE__INDICATOR,
  SHOW_TYPE__LINE,
  SHOW_TYPE__MEASURE,
  SHOW_TYPE__PERCENT_BAR,
  SHOW_TYPE__PERCENT_STRIP,
  SHOW_TYPE__PIE,
  SHOW_TYPE__RADAR,
  SHOW_TYPE__STACKED_BAR,
  SHOW_TYPE__STACKED_STRIP,
  SHOW_TYPE__STRIP,
  SHOW_TYPE__FUNNEL,
  SHOW_TYPE__SUNBURST,
  SHOW_TYPE__TREE_MAP,
  SHOW_TYPE__SCATTER,
  SHOW_TYPE__MAP,
  SHOW_TYPE__PIVOT_TABLE
} from "../../types"

import Area from "./Area"
import ClusterBar from "./ClusterBar"
import Indicator from "./Indicator"
import Line from "./Line"
import Measure from "./Measure"
import PercentBar from "./PercentBar"
import PercentStrip from "./PercentStrip"
import Pie from "./Pie"
import Radar from "./Radar"
import StackedBar from "./StackedBar"
import StackedStrip from "./StackedStrip"
import Strip from "./Strip"
import Funnel from "./Funnel"
import Scatter from "./Scatter"
import TreeMap from "./TreeMap"
import Sunburst from "./Sunburst"
import Map from "./Map"
import Pivotable from "./Pivotable";

export const controlNameMap = {
  [SHOW_TYPE__AREA]: "controlArea",
  [SHOW_TYPE__CLUSTER_BAR]: "controlClusterBar",
  [SHOW_TYPE__INDICATOR]: "controlIndicator",
  [SHOW_TYPE__LINE]: "controlLine",
  [SHOW_TYPE__MEASURE]: "controlMeasure",
  [SHOW_TYPE__PERCENT_BAR]: "controlPercentBar",
  [SHOW_TYPE__PERCENT_STRIP]: "controlPercentStrip",
  [SHOW_TYPE__PIE]: "controlPie",
  [SHOW_TYPE__RADAR]: "controlRadar",
  [SHOW_TYPE__STACKED_BAR]: "controlStackedBar",
  [SHOW_TYPE__STACKED_STRIP]: "controlStackedStrip",
  [SHOW_TYPE__STRIP]: "controlStrip",
  [SHOW_TYPE__FUNNEL]: "controlFunnel",
  [SHOW_TYPE__SCATTER]: "controlScatter",
  [SHOW_TYPE__TREE_MAP]: "controlTreeMap",
  [SHOW_TYPE__SUNBURST]: "controlSunburst",
  [SHOW_TYPE__MAP]: "controlMap",
  [SHOW_TYPE__PIVOT_TABLE]: "controlPivotable"
}

export default {
  [controlNameMap[SHOW_TYPE__AREA]]: Area,
  [controlNameMap[SHOW_TYPE__CLUSTER_BAR]]: ClusterBar,
  [controlNameMap[SHOW_TYPE__INDICATOR]]: Indicator,
  [controlNameMap[SHOW_TYPE__LINE]]: Line,
  [controlNameMap[SHOW_TYPE__MEASURE]]: Measure,
  [controlNameMap[SHOW_TYPE__PERCENT_BAR]]: PercentBar,
  [controlNameMap[SHOW_TYPE__PERCENT_STRIP]]: PercentStrip,
  [controlNameMap[SHOW_TYPE__PIE]]: Pie,
  [controlNameMap[SHOW_TYPE__RADAR]]: Radar,
  [controlNameMap[SHOW_TYPE__STACKED_BAR]]: StackedBar,
  [controlNameMap[SHOW_TYPE__STACKED_STRIP]]: StackedStrip,
  [controlNameMap[SHOW_TYPE__STRIP]]: Strip,
  [controlNameMap[SHOW_TYPE__FUNNEL]]: Funnel,
  [controlNameMap[SHOW_TYPE__SCATTER]]: Scatter,
  [controlNameMap[SHOW_TYPE__TREE_MAP]]: TreeMap,
  [controlNameMap[SHOW_TYPE__SUNBURST]]: Sunburst,
  [controlNameMap[SHOW_TYPE__MAP]]: Map,
  [controlNameMap[SHOW_TYPE__PIVOT_TABLE]]: Pivotable
}
